export interface IPasswordUpdate {

      currentPassword?:string;

      newPassword?:string;
}

export class PasswordUpdate implements IPasswordUpdate {
    constructor(
        public currentPassword?: string,
        public newPassword?: string,
       
    ) {
    }
}